import { render } from "./GameHistory.vue?vue&type=template&id=0714470e&scoped=true"
import script from "./GameHistory.vue?vue&type=script&lang=js"
export * from "./GameHistory.vue?vue&type=script&lang=js"

import "./GameHistory.vue?vue&type=style&index=0&id=0714470e&scoped=true&lang=css"
import "./GameHistory.vue?vue&type=style&index=1&id=0714470e&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0714470e"]])

export default __exports__